import React, { useState } from 'react'

const DeleteIcon = ( {deleteCallback} ) => {

    const [hover, setHover] = useState(false)

    return (
        <div
            onClick={ deleteCallback } 
            onMouseEnter={ () => setHover(true) } 
            onMouseLeave={ () => setHover(false) }
        >
            <div className="row gx-2 align-items-baseline">
                <div className="col">
                    <i className={ hover ? 'fas fa-trash' : 'fas fa-trash' } ></i>
                </div>
                <div className="col" style={{ display: hover ? '' : 'none' }}>
                    <p>Eliminar</p>
                </div>
            </div>

        </div>
    )
}

export default DeleteIcon
